import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BESCHAEFTIGUNG_ARTEN } from '../../../models/beschaeftigung-arten.model';
import { DateRangeComponent } from '../../common/date-range/date-range.component';
import { BerufserfahrungFormGroup } from '../bewerbung-einreichen/bewerbung-einreichen-form-groups';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { TrimInputValueDirective } from '../../../services/form/trim-input-value.directive';
import { Select } from 'primeng/select';
import { TauresMessageModule } from '@taures/taures-components/taures-message';
import { Button } from 'primeng/button';
import { Fieldset } from 'primeng/fieldset';
import { BRANCHEN } from '../../../models/branchen.model';

@Component({
  selector: 'app-werdegang[berufserfahrungForm]',
  templateUrl: './werdegang.component.html',
  styleUrls: ['./werdegang.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [DateRangeComponent, ReactiveFormsModule, FloatLabel, InputText, TrimInputValueDirective, Select, TauresMessageModule, Button, Fieldset],
  standalone: true
})
export class WerdegangComponent {
  protected branches: string[] = BRANCHEN;
  protected beschaeftigungArten: string[] = BESCHAEFTIGUNG_ARTEN;

  @Input()
  public berufserfahrungForm!: FormGroup<BerufserfahrungFormGroup>;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();

  public constructor() {}
}
